import { findAll, find } from "../utils/dom";


const Compartilhar = () =>{
	const btCompartilhar = findAll("[js-compartilhar]");
	if(!btCompartilhar) return;

	async function compartilharNormal(){
		try{
			await navigator.clipboard.writeText(window.location.href);
			const confirmText = find("[js-compartilhe-confirme]");
			confirmText?.classList.add("active");
			setTimeout(()=>{
				confirmText?.classList.remove("active");
			}, 2500);

		}catch(error){
			console.log(error);
		}
	}



	btCompartilhar?.forEach((bt)=>{

		bt.addEventListener("click", (e)=>{
			const tipo = e.target.getAttribute('js-compartilhar');
			switch (tipo){
				case 'Normal':
					compartilharNormal();
				break
			}
		});
	})
}

export default Compartilhar;